import React, { useEffect, useRef } from "react";
import * as styles from "./Toast.module.css";
import { toastMessages } from "../../utils";
import { siteToastMessages } from "../../siteManagement/siteUtils/siteToastMessages";
const globalToastMessage = {
  ...siteToastMessages,
  ...toastMessages,
};
const Toast = () => {
  const toastRef = useRef(null);

  useEffect(() => {
    const handleNewToast = (event) => {
      const { value, type, duration } = event.detail;

      const toast = document.createElement("div");
      toast.className = `${styles.toast} ${styles[`toast_${type}`]} ${
        styles.toast_enter
      }`;
      const msg_type = document.createElement("div");
      msg_type.innerHTML = "";
      msg_type.className = styles.toast_type;
      msg_type.innerHTML = type[0].toUpperCase() + type.slice(1);

      const msg = document.createElement("div");
      // msg.className = "toast-message";
      msg.innerHTML = value;

      const close = document.createElement("span");
      close.className = styles.toast_close;
      close.classList.add(styles[`toast_close_${type}`]);
      close.innerText = "×";
      close.onclick = () => {
        toast.classList.remove(styles.toast_enter);
        toast.classList.add(styles.toast_exit);
      };

      const progress = document.createElement("div");
      progress.className = styles.toast_progress;
      progress.style.animationDuration = `${duration}ms`;

      progress.addEventListener("animationend", () => {
        toast.classList.remove(styles.toast_enter);
        toast.classList.add(styles.toast_exit);
      });

      toast.addEventListener("animationend", (e) => {
        if (e.animationName === styles.toast_exit) {
          toast.remove();
        }
      });
      toast.appendChild(msg_type);
      toast.appendChild(msg);
      toast.appendChild(close);
      toast.appendChild(progress);

      toastRef.current?.appendChild(toast);
    };

    window.addEventListener("iq-toast-event", handleNewToast);
    return () => window.removeEventListener("iq-toast-event", handleNewToast);
  }, []);

  return <div className={styles.toast_container} ref={toastRef}></div>;
};

export const showToast = (message, duration = 3000) => {
  if (!message) return;
  let toastDetails = globalToastMessage[message];
  if (!toastDetails) {
    console.log(`Toast Message info is missing for message - ${message}`);
    toastDetails = globalToastMessage.DEFAULT;
  }
  if (toastDetails?.message) {
    window.dispatchEvent(
      new CustomEvent("iq-toast-event", {
        detail: {
          value: toastDetails.message,
          type: toastDetails.type,
          duration,
        },
      })
    );
  }
};

export default Toast;
